import { makeBooleanDataField, makeInt64DataField, makeStringDataField } from './DataFieldHelper';
function getFullFieldName(instanceName, fieldName) {
    return instanceName ? instanceName + '.' + fieldName : fieldName;
}
/**
 * Adds a data field from a contract to the data fields array.
 * If the data field value is empty, the field is skipped.
 * @param instanceName - The name of the contract instance. Empty if no instance.
 * @param fieldName - The name of the field to add
 * @param value - The value
 * @param dataFields - The array of data fields to which a field will be added
 */
function addStringDataField(dataFields, instanceName, fieldName, value, dataClassification) {
    if (dataClassification === void 0) { dataClassification = 4 /* DataClassification.SystemMetadata */; }
    if (value) {
        dataFields.push(makeStringDataField("".concat(getFullFieldName(instanceName, fieldName)), value, dataClassification));
    }
}
function addBooleanDataField(dataFields, instanceName, fieldName, value) {
    if (typeof value === 'boolean') {
        dataFields.push(makeBooleanDataField("".concat(getFullFieldName(instanceName, fieldName)), value));
    }
}
function addInt64DataField(dataFields, instanceName, fieldName, value) {
    if (typeof value === 'number') {
        dataFields.push(makeInt64DataField("".concat(getFullFieldName(instanceName, fieldName)), value));
    }
}
export var Result = {
    /* Gets data fields for the Office.System.Result contract */
    getFields: function (contract) {
        var instanceName = 'Activity.Result';
        var contractName = 'Office.System.Result';
        var dataFields = [];
        addInt64DataField(dataFields, instanceName, 'Code', contract.code);
        addStringDataField(dataFields, instanceName, 'Type', contract.type);
        addInt64DataField(dataFields, instanceName, 'Tag', contract.tag);
        addBooleanDataField(dataFields, instanceName, 'IsExpected', contract.isExpected);
        dataFields.push(makeStringDataField('zC.Activity.Result', contractName));
        return dataFields;
    }
}; // Result
export var Activity = {
    contractName: 'Office.System.Activity',
    /* Gets data fields for the Office.System.Activity contract */
    getFields: function (contract) {
        var instanceName = 'Activity';
        var dataFields = [];
        addStringDataField(dataFields, instanceName, 'CV', contract.cV);
        addInt64DataField(dataFields, instanceName, 'Duration', contract.duration);
        addInt64DataField(dataFields, instanceName, 'Count', contract.count);
        addInt64DataField(dataFields, instanceName, 'AggMode', contract.aggMode);
        addBooleanDataField(dataFields, instanceName, 'Success', contract.success);
        if (contract.result) {
            dataFields.push.apply(dataFields, Result.getFields(contract.result));
        }
        dataFields.push(makeStringDataField('zC.Activity', this.contractName));
        return dataFields;
    }
}; // Activity
export var User = {
    /* Gets data fields for the Office.System.User contract */
    getFields: function (contract) {
        var instanceName = 'User';
        var dataFields = [];
        addStringDataField(dataFields, instanceName, 'PrimaryIdentityHash', contract.primaryIdentityHash);
        addStringDataField(dataFields, instanceName, 'PrimaryIdentitySpace', contract.primaryIdentitySpace);
        addStringDataField(dataFields, instanceName, 'TenantId', contract.tenantId, 1 /* DataClassification.EssentialServiceMetadata */);
        addStringDataField(dataFields, instanceName, 'TenantGroup', contract.tenantGroup, 1 /* DataClassification.EssentialServiceMetadata */);
        addBooleanDataField(dataFields, instanceName, 'IsAnonymous', contract.isAnonymous);
        addBooleanDataField(dataFields, instanceName, 'IsSignedIn', contract.isSignedIn);
        return dataFields;
    }
}; // User
export var Funnel = {
    /* Gets data fields for the Office.System.Funnel contract */
    getFields: function (instanceName, contract) {
        var dataFields = [];
        addStringDataField(dataFields, instanceName, 'Name', contract.name);
        addStringDataField(dataFields, instanceName, 'State', contract.state);
        return dataFields;
    }
}; // Funnel
export var UserAction = {
    /* Gets data fields for the Office.System.UserAction contract */
    getFields: function (contract) {
        var instanceName = 'UserAction';
        var dataFields = [];
        addInt64DataField(dataFields, instanceName, 'Id', contract.id);
        addStringDataField(dataFields, instanceName, 'Name', contract.name);
        addStringDataField(dataFields, instanceName, 'CommandSurface', contract.commandSurface);
        addStringDataField(dataFields, instanceName, 'ParentName', contract.parentName);
        addStringDataField(dataFields, instanceName, 'TriggerMethod', contract.triggerMethod);
        addInt64DataField(dataFields, instanceName, 'TimeOffsetMs', contract.timeOffsetMs);
        return dataFields;
    }
}; // UserAction
export var Platform;
(function (Platform) {
    Platform["Web"] = "Web";
    Platform["Desktop"] = "Desktop";
    Platform["Universal"] = "Universal";
    Platform["Mobile"] = "Mobile";
    Platform["Win32"] = "Win32";
    Platform["iOS"] = "iOS";
    Platform["Android"] = "Android";
})(Platform || (Platform = {}));
export var App = {
    /* Gets data fields for the Office.System.App contract */
    getFields: function (contract) {
        var instanceName = 'App';
        var dataFields = [];
        addStringDataField(dataFields, instanceName, 'Name', contract.name, 1 /* DataClassification.EssentialServiceMetadata */);
        addStringDataField(dataFields, instanceName, 'Platform', contract.platform, 1 /* DataClassification.EssentialServiceMetadata */);
        addStringDataField(dataFields, instanceName, 'Version', contract.version, 1 /* DataClassification.EssentialServiceMetadata */);
        return dataFields;
    }
}; // App
export var Session = {
    /* Gets data fields for the Office.System.Session contract */
    getFields: function (contract) {
        var instanceName = 'Session';
        var dataFields = [];
        addStringDataField(dataFields, instanceName, 'Id', contract.id, 1 /* DataClassification.EssentialServiceMetadata */);
        addStringDataField(dataFields, instanceName, 'EcsETag', contract.ecsETag, 1 /* DataClassification.EssentialServiceMetadata */);
        return dataFields;
    }
}; // Session
export var HealthQosError = {
    /**
     * Gets data fields for the Health contract
     * See https://aka.ms/asha/docs for documentation on usage and parameters.
     * Generally, use sendHealthQosError() instead of using this contract directly.
     */
    getFields: function (contract) {
        var dataFields = [];
        dataFields.push(makeStringDataField('Pillar', contract.pillar));
        dataFields.push(makeStringDataField('Veto', contract.veto));
        dataFields.push(makeBooleanDataField('IsIntentional', contract.isIntentional));
        dataFields.push(makeBooleanDataField('IsInternal', contract.isInternal));
        dataFields.push(makeBooleanDataField('AlertOnPillar', contract.alertOnPillar));
        dataFields.push(makeBooleanDataField('IsSessionEndingError', contract.isSessionEndingError));
        addBooleanDataField(dataFields, undefined, 'InStaging', contract.inStaging);
        return dataFields;
    }
}; // HealthQosError
export var AudienceGroup;
(function (AudienceGroup) {
    AudienceGroup["Automation"] = "Automation";
    AudienceGroup["Dogfood"] = "Dogfood";
    AudienceGroup["Microsoft"] = "Microsoft";
    AudienceGroup["Insiders"] = "Insiders";
    AudienceGroup["Production"] = "Production";
})(AudienceGroup || (AudienceGroup = {}));
export var Release = {
    /* Gets data fields for the Office.System.Release contract */
    getFields: function (contract) {
        var instanceName = 'Release';
        var dataFields = [];
        addStringDataField(dataFields, instanceName, 'AudienceGroup', contract.audienceGroup, 1 /* DataClassification.EssentialServiceMetadata */);
        return dataFields;
    }
}; // Release
// Source of truth is https://office.visualstudio.com/OE/_git/UnifiedEventSchema?version=GBmain&path=/src/Copilot.tml
// Compiled with TML compiler, and manually modified to add enums and zC field
export var Copilot;
(function (Copilot) {
    var contractName = 'Office.System.Copilot';
    var instanceName = 'Copilot';
    var FeatureActionType;
    (function (FeatureActionType) {
        FeatureActionType["IsEnabled"] = "IsEnabled";
        FeatureActionType["IsSeen"] = "IsSeen";
        FeatureActionType["IsTried"] = "IsTried";
        FeatureActionType["IsKept"] = "IsKept";
        FeatureActionType["IsRejected"] = "IsRejected";
    })(FeatureActionType = Copilot.FeatureActionType || (Copilot.FeatureActionType = {}));
    /**
     * @deprecated - Use FeatureName and SubFeatureName instead
     */
    var Capability;
    (function (Capability) {
        /**
         * @deprecated - Use FeatureName and SubFeatureName instead
         */
        Capability["ContentGeneration"] = "Content Generation";
        /**
         * @deprecated - Use FeatureName and SubFeatureName instead
         */
        Capability["Commanding"] = "Commanding";
        /**
         * @deprecated - Use FeatureName and SubFeatureName instead
         */
        Capability["QAandSummaries"] = "QA and Summaries";
        /**
         * @deprecated - Use FeatureName and SubFeatureName instead
         */
        Capability["Collaboration"] = "Collaboration";
        /**
         * @deprecated - Use FeatureName and SubFeatureName instead
         */
        Capability["Suggestions"] = "Suggestions";
    })(Capability = Copilot.Capability || (Copilot.Capability = {}));
    var EntryPoint;
    (function (EntryPoint) {
        EntryPoint["Chat"] = "Chat";
        EntryPoint["Canvas"] = "Canvas";
    })(EntryPoint = Copilot.EntryPoint || (Copilot.EntryPoint = {}));
    /**
     * @deprecated - Use FeatureName and SubFeatureName instead
     */
    var Verb;
    (function (Verb) {
        /**
         * @deprecated - Use FeatureName and SubFeatureName instead
         */
        Verb["Create"] = "Create";
        /**
         * @deprecated - Use FeatureName and SubFeatureName instead
         */
        Verb["Command"] = "Command";
        /**
         * @deprecated - Use FeatureName and SubFeatureName instead
         */
        Verb["Ask"] = "Ask";
        /**
         * @deprecated - Use FeatureName and SubFeatureName instead
         */
        Verb["Summarize"] = "Summarize";
        /**
         * @deprecated - Use FeatureName and SubFeatureName instead
         */
        Verb["Share"] = "Share";
        /**
         * @deprecated - Use FeatureName and SubFeatureName instead
         */
        Verb["Analyze"] = "Analyze";
    })(Verb = Copilot.Verb || (Copilot.Verb = {}));
    /* Gets data fields for the Office.System.Copilot contract */
    function getFields(contract) {
        var dataFields = [];
        addStringDataField(dataFields, instanceName, 'FeatureActionType', contract.featureActionType);
        addBooleanDataField(dataFields, instanceName, 'IsUserInitiated', contract.isUserInitiated);
        addStringDataField(dataFields, instanceName, 'FeatureName', contract.featureName);
        addStringDataField(dataFields, instanceName, 'SubFeatureName', contract.subFeatureName);
        addStringDataField(dataFields, instanceName, 'Capability', contract.capability);
        addBooleanDataField(dataFields, instanceName, 'IsThumbsUp', contract.isThumbsUp);
        addStringDataField(dataFields, instanceName, 'EntryPoint', contract.entryPoint);
        addStringDataField(dataFields, instanceName, 'Verb', contract.verb);
        addStringDataField(dataFields, instanceName, 'InteractionId', contract.interactionId);
        dataFields.push(makeStringDataField("zC.".concat(instanceName), contractName));
        return dataFields;
    }
    Copilot.getFields = getFields;
})(Copilot || (Copilot = {})); // Copilot
// Source of truth is https://office.visualstudio.com/DefaultCollection/_git/Office?path=/liblet/telemetryevent/Asha.tml
export var Asha;
(function (Asha) {
    var contractName = 'Office.System.Asha';
    var instanceName = 'Asha';
    var EventType;
    (function (EventType) {
        EventType["Pillar"] = "Pillar";
        EventType["Error"] = "Error";
    })(EventType = Asha.EventType || (Asha.EventType = {}));
    /* Gets data fields for the Office.System.Asha contract */
    function getFields(contract) {
        var dataFields = [];
        addStringDataField(dataFields, instanceName, 'EventType', contract.eventType);
        addStringDataField(dataFields, instanceName, 'Pillar', contract.pillar);
        addStringDataField(dataFields, instanceName, 'Scenario', contract.scenario);
        addStringDataField(dataFields, instanceName, 'Veto', contract.veto);
        addStringDataField(dataFields, instanceName, 'Error', contract.error);
        addBooleanDataField(dataFields, instanceName, 'InStaging', contract.inStaging);
        addBooleanDataField(dataFields, instanceName, 'IsSessionEndingError', contract.isSessionEndingError);
        addBooleanDataField(dataFields, instanceName, 'IsIntentional', contract.isIntentional);
        addBooleanDataField(dataFields, instanceName, 'IsInternal', contract.isInternal);
        dataFields.push(makeStringDataField("zC.".concat(instanceName), contractName));
        return dataFields;
    }
    Asha.getFields = getFields;
})(Asha || (Asha = {})); // Asha
//# sourceMappingURL=Contracts.js.map